type ScheduleItemFormContainerProps = React.PropsWithChildren<{}>;

export function ScheduleWithDeliveryItemFormContainer({
  children,
}: ScheduleItemFormContainerProps) {
  return <div className="px-4 py-3">{children}</div>;
}
